import { Component, OnInit, Input } from '@angular/core';
import { MessageService, MenuItem } from 'primeng/api';
import { ConfigService, AppDataService, PartnerDashboardService } from 'app/services';
import { Utils } from 'app/utils';
import { CustomWindow } from 'app/@types';

declare let window: CustomWindow;

enum PartnerDashboardTab {
    SalesTotal = '1',
    OrderVolume = '2',
    TicketSize = '3'
}

@Component({
    selector: 'partner-dashboard',
    templateUrl: './partner-dashboard.component.html',
    styleUrls: ['./partner-dashboard.component.scss'],
    providers: [MessageService]
})
export class PartnerDashboardComponent implements OnInit {
    @Input()
    public menuPermissionActive!: string;

    public adminUrl: string = window['adminUrl'];

    public welcomeTitle: string = '';

    public locations: Array<any> = [{Id: 0, Name: 'All'}];
    public selectedLocationId: number = 0;

    public periods: Array<any> = [
        { Id: 1, Name: 'Yesterday' },
        { Id: 2, Name: 'Previous week' },
        { Id: 3, Name: 'Previous month' }
    ];
    public selectedPeriodId: number = 1;

    public partner: any = {};

    public menuItems: MenuItem[] = [
        {
            id: PartnerDashboardTab.SalesTotal,
            label: 'Sales Total'
        },
        {
            id: PartnerDashboardTab.OrderVolume,
            label: 'Order Volume'
        },
        {
            id: PartnerDashboardTab.TicketSize,
            label: 'Ticket Size'
        }
    ];

    public partnerDashboardTab = PartnerDashboardTab;
    public activeItem: MenuItem = this.menuItems[0];

    public salesChartData: any;
    public salesChartOptions: any = {
        plugins: {
            legend: {
                position: 'bottom'
            }
        }
    };
    public salesDataState: number = 0;

    public isSpinnerVisible: boolean = true;

    constructor(
        private messageService: MessageService,
        public configService: ConfigService,
        public appData: AppDataService,
        private partnerDashboardService: PartnerDashboardService) {
    }

    ngOnInit(): void {
        this.welcomeTitle = `Good ${Utils.getDayPeriod()}`;

        Promise.all([
            this.getPartnerInfo(),
            this.getPartnerDashboard()])
            .then(() => {
                this.isSpinnerVisible = false;
            });
    }

    private getPartnerInfo(): Promise<any> {
        const dto = {
            TimeZoneOffset: Utils.getTimezoneOffset()
        };

        return this.partnerDashboardService.getPartnerInfo(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.partner = data;

                this.locations = this.locations.concat(this.partner.Locations);
            });
    }

    public getPartnerDashboard(): Promise<any> {
        this.isSpinnerVisible = true;

        const dto = {
            TimeZoneOffset: Utils.getTimezoneOffset(),
            LocationId: this.selectedLocationId,
            PeriodId: this.selectedPeriodId
        };

        return this.partnerDashboardService.getPartnerDashboard(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.salesChartData = {
                    labels: data.SalesChartLabels, // ['9am', '10am', '11am', '12am', '13am', '14am']
                    datasets: [
                        {
                            label: data.SalesChartDataLabel1, // 'Today'
                            data: data.SalesChartData1, //[10, 20, 23, 30, 32, 40]
                            borderColor: '#004060'
                        },
                        {
                            label: data.SalesChartDataLabel2, // 'Yesterday'
                            data: data.SalesChartData2, //[5, 24, 23, 32, 33, 38]
                            borderColor: '#02BC77',
                        }
                    ]
                };

                this.salesDataState = data.SalesChartLabels.length ? 2 : 1;
            });
    }

    public onFilterChange(): void {
        this.getPartnerDashboard().then(() => {
            this.isSpinnerVisible = false;
        });
    }

    public onActiveItemChange(item: any): void {
        this.activeItem = item;
    }
}
